import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'

import ExTableColumn from 'ex-table-column';

import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/vars.less'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
//import '@/permission'
import axios, { AxiosInstance } from 'axios'
import './util/rem'

import './plugins/fitcolumns'
import { LogHelper } from "@/common/LogHelper";
document.title = "网页平台 | 条码威视";
// Vue.prototype.$params = params  //挂载到vue实例上,以便项目随处可用
Vue.use(v => {
  v.prototype.$axios = axios
});
Vue.use(ElementUI);

Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
});

//使用表格自适应控件
Vue.component(ExTableColumn.name, ExTableColumn);


Vue.config.productionTip = false;

//系统错误捕获
// const errorHandler = (error, vm , info) => {
//   console.error("|++++++++抛出全局异常开始++++++++|");
//   console.error(vm);
//   console.error("报错页面:"+vm.$route.fullPath);
//   console.error(error);
//   console.error("info");
//   console.error(info);
//   console.error("|========抛出全局异常结束========|");
// };
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = error => errorHandler(error, this);

//Vue全局异常捕获，落日志
const errorHandler = (err, vm, info) => {
  console.error("========抛出全局异常开始========"+"|报错页面:"+vm.$route.fullPath+"|"+"info:"+info);
  console.error(vm);
  console.error(err);
  console.error("========抛出全局异常结束========");


}
Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error) => errorHandler(error, this, "$throw");


// //系统警告捕获
// const warnHandler = (warn, vm , info) => {
//   console.warn("|++++++++抛出全局警告开始++++++++|");
//   console.warn(vm);
//   console.warn("警告页面:"+vm.$route.fullPath);
//   console.warn(warn);
//   console.warn("info");
//   console.warn(info);
//   console.warn("|========抛出全局警告结束========|");
// };
// Vue.config.warnHandler = warnHandler;

////重写console.log方法，如果isProduct=true，那么控制台就不会显示console.log
//let isProduct = false;
//console.log = (function (oriLogFunc) {
//  return function () {
//    //判断配置文件是否开启日志调试
//    // if (!Config.isProduct) {
//      if (!isProduct) {
//      try{
//        oriLogFunc.call(console, ...arguments);
//      }catch(e){
//        console.error('console.log error', e);
//      }
//    }
//  }
//})(console.log);
////


let lastDate = Date.now();
const checkSuspend = () => {
  setTimeout(() => {
    const now = Date.now();
    const minutes = (now - lastDate) / (1000 * 60);
    if (minutes > 2) {
      LogHelper.WriteLog(`JS线程挂起${minutes}`);
    }
    lastDate = now;

    checkSuspend();
  }, 5000);
}

checkSuspend();

var cvapp = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
